module.exports = __webpack_public_path__ + "static/media/act-advantage.1305dfd9.png";